import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';

import { AbilitiesSelectors } from '@recruitee/abilities/data';
import { Ability } from '@recruitee/http/types';

import { FeatureData, FeaturesGuardModel } from '../feature-guard.model';
import { GuardedFeature } from '../feature-guard.types';

@Component({
  selector: 'rt-feature-guard-empty',
  templateUrl: './feature-guard-empty.component.html',
  styleUrls: ['./feature-guard-empty.component.less'],
})
export class FeatureGuardEmptyComponent {
  public featureData: FeatureData;
  public canUpgrade: boolean = false;

  public paddingTopLarge: boolean = false;

  constructor(
    private store: Store,
    private model: FeaturesGuardModel,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  public ngOnInit() {
    const feature: GuardedFeature = this.route.snapshot.data.feature;
    const paddingTopLarge: boolean = this.route.snapshot.data.paddingTopLarge;

    if (feature) {
      this.featureData = this.model.data[feature];
      this.store
        .select(AbilitiesSelectors.hasOne(Ability.ManageSubscription))
        .pipe(first())
        .subscribe(canManageSubscription => {
          this.canUpgrade = canManageSubscription;
        });

      if (this.featureData.analytics) {
        this.featureData.analytics.discrimination();
      }
    }

    this.paddingTopLarge = paddingTopLarge || false;
  }

  public openPlanPicker() {
    this.router.navigate([{ outlets: { dialog: ['order', 'select-product'] } }]);

    if (this.featureData.analytics) {
      this.featureData.analytics.cta();
    }
  }
}
